import "bootstrap/dist/css/bootstrap.min.css"
import "./index.css"
import Nav from "./ui/Nav"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Layout from "./ui/Layout"
import Home from "./pages/Home"
import Setup from "./pages/Setup"
import Config from "./pages/Config"
import Sprites from "./pages/Sprites"
import Animation from "./pages/Animation"
import Checkpoint from "./pages/Checkpoint"
import PlayerInput from "./pages/PlayerInput"
import PlayerProjectiles from "./pages/PlayerProjectiles"
import Enemies from "./pages/Enemies"
import CollisionDetection from "./pages/CollisionDetection"
import KeepingScore from "./pages/KeepingScore"
import Sound from "./pages/Sounds"

function App() {
  return (
    <div className="App">
      <Nav />
      <Layout>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Setup" element={<Setup />} />
            <Route path="/Config" element={<Config />} />
            <Route path="/Sprites" element={<Sprites />} />
            <Route path="/Animation" element={<Animation />} />
            <Route path="/Checkpoint" element={<Checkpoint />} />
            <Route path="/PlayerInput" element={<PlayerInput />} />
            <Route path="/PlayerProjectiles" element={<PlayerProjectiles />} />
            <Route path="/Enemies" element={<Enemies />} />
            <Route path="/KeepingScore" element={<KeepingScore />} />
            <Route path="/Sound" element={<Sound />} />
            <Route
              path="/CollisionDetection"
              element={<CollisionDetection />}
            />
          </Routes>
        </BrowserRouter>
      </Layout>
    </div>
  )
}

export default App
